import styled from 'styled-components'

export const StyledQtyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

`

export const StyledLabel = styled.span`
  color: #694;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 165%;
`

export const StyledLabelRed = styled(StyledLabel)`
  color: #C33;
`
